var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgVoucher = function SvgVoucher(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 800,
    height: 800,
    baseProfile: "tiny",
    viewBox: "-63 65 128 128"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-26.8 131.5h7.2v7.2h-7.2zm0-14.2h7.2v7.2h-7.2zm-33.9.7h.2c5.9 0 10.5 4.6 10.5 10.5S-54.6 139-60.5 139v22.7H62.7v-23.5h-.2c-5.9 0-10.5-4.6-10.5-10.5s4.6-10.5 10.5-10.5V94.4H-60.7zm82.2-15.1v7.2h7.2v-7.2h25.4v7.7c-6.3 3.1-10.5 9.4-10.5 17s4.2 13.8 10.5 17v8.6H28.7V146h-7.2v7.2h-41.3V146H-27v7.2h-25.2v-7.7c6.3-3.1 10.5-9.4 10.5-17s-4.2-13.8-10.5-17v-8.6h25.4v7.2h7.2v-7.2zm0 14.4h7.2v7.2h-7.2zm0 14.2h7.2v7.2h-7.2z"
  })));
};
export default SvgVoucher;